var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("base-navigation-tabs", { attrs: { items: _vm.links } }),
      _c(
        "v-card",
        { attrs: { "min-height": "80vh", tile: "", elevation: "0" } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }